import React from 'react';
import SectionForm from "./sectionForm";
import {Checkbox, Form, Grid, Input} from "semantic-ui-react";
import Logos from "./logos";
import Dropdown from "../../../components/Dropdown";
import DatePicker from "../../../components/DatePicker/DatePicker";
import Info from "../../../components/Info";
import {getDate} from "../../../services/dateUtils";
import {getCarrierUiExtension} from "./carrierExtensions";

const TariffSection = ({form, errors, options, disabled}) => {
    const carrierExtension = getCarrierUiExtension(form.selectedTariff);
    const shortTariffTitle = carrierExtension.getShortTariffTitle(form.selectedTariff);
    return (
        <SectionForm
            label={'Перевозка'}
            icon={<svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.78139 17.8132H7.77509C7.45294 17.8132 7.19495 18.0944 7.19495 18.4412C7.19495 18.788 7.45924 19.0692 7.78139 19.0692C8.10355 19.0692 8.36473 18.788 8.36473 18.4412C8.36473 18.0944 8.10355 17.8132 7.78139 17.8132Z"
                    fill="#135CA9"/>
                <path
                    d="M12.7688 17.8132H12.7626C12.4404 17.8132 12.1824 18.0944 12.1824 18.4412C12.1824 18.788 12.4467 19.0692 12.7688 19.0692C13.091 19.0692 13.3522 18.788 13.3522 18.4412C13.3522 18.0944 13.091 17.8132 12.7688 17.8132Z"
                    fill="#135CA9"/>
                <path
                    d="M21.9661 17.8132H21.9599C21.6377 17.8132 21.3796 18.0944 21.3796 18.4412C21.3796 18.788 21.6439 19.0692 21.9661 19.0692C22.2882 19.0692 22.5494 18.788 22.5494 18.4412C22.5494 18.0944 22.2882 17.8132 21.9661 17.8132Z"
                    fill="#135CA9"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M27.4573 9.37615L28.2417 10.2205C28.5874 10.5927 28.7778 11.0875 28.7777 11.6138V17.0991C28.7777 17.8155 28.2364 18.3983 27.5709 18.3983H25.0358L25.0363 18.4176L25.0366 18.4291L25.0368 18.4412C25.0368 20.2678 23.6564 21.754 21.9596 21.754C20.4623 21.754 19.212 20.5965 18.9386 19.0692H15.7837C15.5103 20.5965 14.2599 21.754 12.7626 21.754C11.7374 21.754 10.8282 21.2109 10.2687 20.3784C9.70923 21.2109 8.80008 21.754 7.77481 21.754C6.27751 21.754 5.02723 20.5965 4.75376 19.0692H3.41046C2.74499 19.0692 2.20366 18.4864 2.20366 17.7699V16.1681H1.54005C0.874586 16.1681 0.333252 15.5853 0.333252 14.8688V1.54343C0.333252 0.827077 0.874586 0.244202 1.54005 0.244202H18.5377C19.2032 0.244202 19.6755 0.752683 19.6755 1.46912V3.04641H25.7006C26.0227 3.04641 26.2839 3.32759 26.2839 3.67442C26.2839 3.95485 26.113 4.19224 25.8773 4.27287L27.4573 9.37615ZM3.41031 17.8133H4.75361C4.84889 17.2809 5.06301 16.7939 5.36479 16.3847H3.37018V17.7701C3.37018 17.7939 3.38815 17.8133 3.41031 17.8133ZM7.77464 20.4982C6.72114 20.4982 5.8641 19.5755 5.8641 18.4414C5.8641 17.3115 6.71476 16.3918 7.76274 16.3847H7.78669C8.83467 16.3917 9.68533 17.3114 9.68533 18.4414C9.68525 19.5755 8.82814 20.4982 7.77464 20.4982ZM10.8522 18.4414C10.8522 19.5755 11.7093 20.4982 12.7628 20.4982C13.8163 20.4982 14.6733 19.5755 14.6734 18.4414C14.6734 17.3114 13.8227 16.3917 12.7747 16.3847H12.7508C11.7028 16.3918 10.8522 17.3115 10.8522 18.4414ZM18.9385 17.8132H15.7836C15.7836 17.8132 15.4261 16.5771 15.1242 16.168C15.4464 16.168 15.6846 16.1034 15.6846 15.7566C15.6846 15.4098 15.4234 15.1286 15.1012 15.1286H1.53992C1.51775 15.1286 1.49979 14.967 1.49979 14.9431V0.31848C12.5452 0.295312 2.16201 0.276406 1.56626 0.275322L1.56626 0.275322L1.56625 0.275322C1.54833 0.275289 1.53927 0.275273 1.53992 0.275273H18.5377V15.1286L17.5954 15.1287C17.359 15.1287 17.3642 15.1718 17.3838 15.3319C17.3908 15.3899 17.3998 15.4633 17.3998 15.5556C17.3998 15.6939 17.3486 15.8192 17.3074 15.92C17.2453 16.072 17.2061 16.168 17.3998 16.168H19.6753C19.3735 16.5771 19.0338 17.2808 18.9385 17.8132ZM22.5833 9.75854H26.3461L25.488 6.98718H22.5431V9.71533C22.5431 9.73919 22.5611 9.75854 22.5833 9.75854ZM21.9596 20.4982C20.9061 20.4982 20.0491 19.5754 20.0491 18.4413C20.0491 17.3115 20.8997 16.3917 21.9477 16.3847H21.9597L21.9637 16.3845C23.0154 16.3868 23.8703 17.3086 23.8703 18.4412C23.8701 19.5754 23.0131 20.4982 21.9596 20.4982ZM27.5709 17.1425C27.5931 17.1425 27.6111 17.1231 27.6111 17.0993V14.3711H26.9475C26.6253 14.3711 26.3641 14.0899 26.3641 13.7431C26.3641 13.3963 26.6253 13.1151 26.9475 13.1151H27.6111V11.6139C27.6111 11.4231 27.542 11.2437 27.4167 11.1087L27.3293 11.0146H22.5831C21.9177 11.0146 21.3763 10.4318 21.3763 9.7154V6.35924C21.3763 6.01241 21.6375 5.73123 21.9597 5.73123H25.099L24.6566 4.30239L19.6755 4.30239L19.6755 15.1288H21.9477C21.9517 15.1288 21.9556 15.1285 21.9597 15.1285C23.2284 15.1285 24.3201 15.9596 24.7902 17.1425H27.5709Z"
                      fill="#135CA9"/>
                <path
                    d="M1.99988 2.00001C1.99988 1.44773 2.44759 1.00002 2.99988 1.00002H22.7599C23.3122 1.00002 23.7599 1.44773 23.7599 2.00002V17.4007H2.99988C2.44759 17.4007 1.99988 16.9529 1.99988 16.4006V2.00001Z"
                    fill="#135CA9"/>
                <path
                    d="M1.99988 2.26158H21.4799C22.0322 2.26158 22.4799 2.7093 22.4799 3.26158V16.139H1.99988V2.26158Z"
                    fill="white"/>
                <path
                    d="M1.99988 3.52315H20.1999C20.7522 3.52315 21.1999 3.97087 21.1999 4.52315V14.8774H1.99988V3.52315Z"
                    fill="#99D402"/>
            </svg>}
        >
            <Form className={'tariff-section'}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Form.Field error={errors['carrierName']}>
                                <label>
                                    Транспортная компания
                                </label>
                                <Input
                                    disabled={disabled}
                                    value={(form.selectedTariff || {}).carrierName || ''}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Logos name={(form.selectedTariff || {}).carrierCode}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Form.Field error={errors['carrierServiceName']}>
                                <label>
                                    Тариф
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Input
                                        disabled={disabled}
                                        value={shortTariffTitle}
                                        style={{ flex: 1 }}
                                    />
                                    {(form.selectedTariff || {}).carrierServiceDescription && (
                                        <Info
                                            className='carrier-tariff-inline__icon'
                                            name={(form.selectedTariff || {}).carrierName}
                                            label={(form.selectedTariff || {}).carrierServiceName}
                                            text={(form.selectedTariff || {}).carrierServiceDescription}
                                            position={'right'}
                                            offset={[10]}
                                        />
                                    )}
                                </div>
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Form.Field error={errors['deliveryTypeCode']}>
                                <label>
                                    Тип доставки
                                </label>
                                <Dropdown
                                    onChange={()=>null}
                                    disabled={disabled}
                                    name={'deliveryTypeCode'}
                                    value={form.deliveryTypeCode}
                                    options={options.deliveryTypes}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Form.Field error={errors['departureDate']}>
                                <label>
                                    Плановая дата отгрузки
                                </label>
                                <DatePicker
                                    name="departureDate"
                                    onChange={()=>null}
                                    disabled
                                    dateFormat='dd.MM.yyyy'
                                    placeholderText='дд.мм.гггг'
                                    value={form.departureDate ? (form.departureDate instanceof Date 
                                        ? (isNaN(form.departureDate.getTime()) ? null : form.departureDate)
                                        : getDate(form.departureDate)) 
                                    : null}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={9}>
                            {
                                (options.carrierServices || []).map(s => (
                                    <Form.Field key={s.name} className='result-step__item'>
                                        <Checkbox
                                            disabled={disabled}
                                            checked={(form.services || []).includes(s.value)}
                                        />
                                        <div className='checkbox-label'>
                                            {s.name}
                                            {s.info && <Info
                                                name={s.name}
                                                text={s.info}
                                                position={'right'}
                                                offset={[10]}
                                            />}
                                        </div>

                                    </Form.Field>
                                ))
                            }
                        </Grid.Column>
                        {/*<Grid.Column width={7} className='left-border'>
                            <Form.Field>
                                <label>
                                    Температурный режим, °С
                                </label>
                                <Input
                                    disabled
                                    value={`${form.tempConditionLow || '-'} — ${form.tempConditionHigh || '-'}`}
                                />
                            </Form.Field>
                        </Grid.Column>*/}
                    </Grid.Row>
                </Grid>
            </Form>
        </SectionForm>
    );
};

export default TariffSection;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tariffSection.jsx